import React from "react";
import Admin from "../components/admin/Admin";

const AdminPage = () => {
  return <Admin />;
};

export default AdminPage;
